import { http } from '@/utils/http.js';
import { teamPath } from '@/utils/paths.js';

export const EmailsApi = {
  index(query) {
    return http.get(`${teamPath()}/emails`, { params: query }).then((response) => response.data);
  },

  // creates a new email parse based on the id of the existing one
  store(id) {
    return http.post(`${teamPath()}/emails/${id}/retry`).then((response) => response.data.data.id);
  },

  show(id) {
    return http.get(`${teamPath()}/emails/${id}`).then((response) => response.data.data);
  },
};
